var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _radialGradient, _linearGradient12, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-26 0 512 512.0005",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0016413824,
    x2: 480.8798028718,
    xlinkHref: "#a",
    y1: 79.3729847328,
    y2: 627.866873747
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0343,
    stopColor: "#9fb3d5",
    stopOpacity: 0.035294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4515,
    stopColor: "#8898af",
    stopOpacity: 0.45098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#798898",
    stopOpacity: 0.788235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 354.7329878838,
    x2: 226.502633177,
    xlinkHref: "#c",
    y1: 582.8864497136,
    y2: 454.6560950068
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 209.6960753672,
    x2: 209.6960753672,
    xlinkHref: "#a",
    y1: 454.034767681,
    y2: 538.4471396382
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 488.8564651228,
    x2: 294.0458025916,
    xlinkHref: "#c",
    y1: 242.9633797314,
    y2: 48.1527172002
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 379.1370266052,
    x2: 379.1370266052,
    y1: 161.6343534128,
    y2: 93.876244298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 379.1381309194,
    x2: 379.1381309194,
    xlinkHref: "#a",
    y1: 194.5708256044,
    y2: 149.9585397684
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 414.5967563516,
    x2: 414.5967563516,
    y1: 170.4718787788,
    y2: 107.8339726484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2115,
    stopColor: "#fd4470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4685,
    stopColor: "#f83565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#ef1d52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 397.9065531016,
    x2: 369.2790145262,
    y1: 180.8169938122,
    y2: 80.3603420198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ac9a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351,
    stopColor: "#38c69d",
    stopOpacity: 0.035294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4167,
    stopColor: "#23aa82",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#169971",
    stopOpacity: 0.752941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11936b"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4873,
    stopColor: "#ffc636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6746,
    stopColor: "#ffc22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9203,
    stopColor: "#ffb112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 359.2514400214,
    cy: 53.5437783402,
    gradientUnits: "userSpaceOnUse",
    r: 107.6714376376,
    xlinkHref: "#k"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 -1650.056283 -2692.517145)",
    gradientUnits: "userSpaceOnUse",
    x1: -2051.5305,
    x2: -1968.9471,
    y1: -2793.3867,
    y2: -2710.8035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe600"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 379.136926213,
    cy: 81.4414656216,
    gradientUnits: "userSpaceOnUse",
    r: 64.0565483086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#fffcf8",
    stopOpacity: 0.05098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffcf8",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 379.136926213,
    cy: 81.4414656216,
    gradientUnits: "userSpaceOnUse",
    r: 53.3675899902,
    xlinkHref: "#k"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 373.4354523906,
    cy: 38.662040181,
    gradientUnits: "userSpaceOnUse",
    r: 90.5455322396,
    xlinkHref: "#k"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m416.535156 512h-340.640625c-15.859375 0-28.71875-12.855469-28.71875-28.714844v-416.347656c0-15.859375 12.859375-28.714844 28.71875-28.714844h340.640625c15.859375 0 28.714844 12.855469 28.714844 28.714844v416.347656c0 15.859375-12.855469 28.714844-28.714844 28.714844zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m75.894531 512h340.640625c15.859375 0 28.714844-12.855469 28.714844-28.714844v-29.683594l-54.640625-54.640624c-5.25-5.777344-12.828125-9.40625-21.253906-9.40625h-322.179688v93.730468c0 15.859375 12.855469 28.714844 28.71875 28.714844zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m369.355469 389.554688h-340.640625c-15.859375 0-28.714844 12.859374-28.714844 28.714843v37.855469c0 30.859375 25.015625 55.875 55.878906 55.875h363.511719c-11.773437 0-21.316406-9.542969-21.316406-21.320312v-72.410157c0-15.855469-12.855469-28.714843-28.71875-28.714843zm0 0",
    fill: "url(#e)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a1b5d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.921875 194.40625h304.585937v16.652344h-304.585937zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.921875 259.976562h304.585937v16.652344h-304.585937zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.921875 325.550781h242.539063v16.652344h-242.539063zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.921875 133.253906h163.5625v16.648438h-163.5625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.921875 74.289062h163.5625v28.765626h-163.5625zm0 0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m445.25 66.9375c0-15.859375-12.855469-28.714844-28.714844-28.714844h-97.933594c-.300781 1.695313-1.335937 3.175782-2.851562 4.019532l-9.355469 5.207031c-2.328125 1.296875-3.457031 4.027343-2.730469 6.589843l2.929688 10.300782c.503906 1.773437.125 3.683594-1.019531 5.128906l-6.640625 8.414062c-1.648438 2.085938-1.648438 5.03125 0 7.117188l6.640625 8.414062c1.144531 1.445313 1.523437 3.355469 1.019531 5.128907l-2.929688 10.300781c-.726562 2.5625.402344 5.292969 2.730469 6.589844l.429688.238281 12.234375 12.714844.847656 7.246093c.238281 2.03125 1.527344 3.722657 3.3125 4.542969.570312 1.246094 1.570312 2.242188 2.8125 2.816407.199219.425781.445312.816406.734375 1.175781l-.015625 78.542969c0 2.476562 1.445312 4.425781 3.378906 5.359374l115.121094 115.117188zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m422.195312 227.652344-43.066406-29.273438-43.078125 29.257813c-3.953125 2.683593-9.300781-.148438-9.296875-4.925781l.023438-133.097657 104.746094.019531-.027344 133.097657c0 4.777343-5.347656 7.609375-9.300782 4.921875zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m379.128906 198.378906 18.539063 12.601563.023437-121.351563-37.085937-.007812-.023438 121.355468zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m431.523438 89.636719-.027344 133.09375c0 4.78125-5.347656 7.609375-9.300782 4.925781l-24.523437-16.675781.023437-121.347657zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m326.769531 140.324219 70.132813 70.136719 25.292968 17.191406c3.953126 2.6875 9.300782-.144532 9.300782-4.921875l.023437-133.09375-104.742187-.019531zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m459.339844 85-6.640625 8.414062c-1.144531 1.445313-1.523438 3.355469-1.019531 5.128907l2.929687 10.300781c.730469 2.5625-.402344 5.292969-2.730469 6.589844l-9.355468 5.207031c-1.613282.898437-2.695313 2.519531-2.910157 4.351563l-1.246093 10.640624c-.308594 2.644532-2.394532 4.730469-5.039063 5.039063l-10.640625 1.246094c-1.832031.214843-3.453125 1.296875-4.351562 2.910156l-5.207032 9.355469c-1.296875 2.328125-4.023437 3.457031-6.589844 2.730468l-10.300781-2.929687c-1.773437-.503906-3.679687-.125-5.128906 1.019531l-8.414063 6.640625c-2.085937 1.648438-5.03125 1.648438-7.117187 0l-8.414063-6.640625c-1.445312-1.144531-3.355468-1.523437-5.128906-1.019531l-10.300781 2.929687c-2.5625.726563-5.292969-.402343-6.589844-2.730468l-5.207031-9.355469c-.898438-1.613281-2.519531-2.695313-4.351562-2.910156l-10.640626-1.246094c-2.644531-.3125-4.730468-2.394531-5.039062-5.039063l-1.246094-10.640624c-.214844-1.835938-1.296875-3.453126-2.910156-4.351563l-9.355469-5.207031c-2.328125-1.296875-3.457031-4.027344-2.730469-6.589844l2.929688-10.300781c.503906-1.773438.125-3.683594-1.019531-5.128907l-6.640625-8.414062c-1.648438-2.085938-1.648438-5.03125 0-7.121094l6.640625-8.410156c1.144531-1.449219 1.523437-3.355469 1.019531-5.132812l-2.929688-10.296876c-.726562-2.566406.402344-5.292968 2.730469-6.589843l9.355469-5.210938c1.613281-.898437 2.695312-2.515625 2.910156-4.347656l1.246094-10.644531c.3125-2.640625 2.394531-4.726563 5.039062-5.035156l10.640626-1.246094c1.835937-.214844 3.453124-1.300782 4.351562-2.910156l5.207031-9.355469c1.296875-2.328125 4.027344-3.460938 6.589844-2.730469l10.300781 2.925781c1.773438.503907 3.683594.128907 5.128906-1.015625l8.414063-6.640625c2.085937-1.652343 5.03125-1.652343 7.117187 0l8.414063 6.640625c1.449219 1.144532 3.355469 1.523438 5.128906 1.015625l10.300781-2.925781c2.5625-.730469 5.292969.402344 6.589844 2.730469l5.207032 9.355469c.898437 1.613281 2.519531 2.695312 4.351562 2.910156l10.640625 1.246094c2.644531.308593 4.730469 2.394531 5.039063 5.035156l1.246093 10.644531c.214844 1.832031 1.296875 3.453125 2.910157 4.351563l9.355468 5.207031c2.328125 1.296875 3.457032 4.023437 2.730469 6.589843l-2.929687 10.296876c-.503907 1.777343-.125 3.683593 1.019531 5.132812l6.640625 8.410156c1.648437 2.089844 1.648437 5.035156 0 7.121094zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m432.503906 81.441406c0 29.472656-23.894531 53.367188-53.367187 53.367188-29.472657 0-53.367188-23.894532-53.367188-53.367188s23.894531-53.367187 53.367188-53.367187c29.472656 0 53.367187 23.894531 53.367187 53.367187zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m451.609375 81.441406c0 40.023438-32.449219 72.472656-72.472656 72.472656-40.023438 0-72.46875-32.449218-72.46875-72.472656 0-40.023437 32.445312-72.472656 72.46875-72.472656 40.023437 0 72.472656 32.449219 72.472656 72.472656zm0 0",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m432.503906 81.441406c0 29.472656-23.894531 53.367188-53.367187 53.367188-29.472657 0-53.367188-23.894532-53.367188-53.367188s23.894531-53.367187 53.367188-53.367187c29.472656 0 53.367187 23.894531 53.367187 53.367187zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m422.621094 81.441406c0 24.015625-19.46875 43.484375-43.484375 43.484375s-43.484375-19.46875-43.484375-43.484375 19.46875-43.484375 43.484375-43.484375 43.484375 19.46875 43.484375 43.484375zm0 0",
    fill: "url(#p)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificate);
export default __webpack_public_path__ + "static/media/icon-certificate.08e492ef7021b058d72e05ba82ad38a4.svg";
export { ForwardRef as ReactComponent };